module.exports = __webpack_public_path__ + "img/app.5e1f5191.png";